export interface Environment {
  production: boolean
  AUTH_URL: string
  API_URL: string
  APP_VERSION: string
  NOUBA_URL: string
}

const getEnv = (): Environment => {
  // Vérifier si on est en mode dev (via REACT_APP_ENV)
  const isDev = process.env.REACT_APP_ENV === "dev"
  if (isDev) {
    return {
      production: false,
      AUTH_URL: process.env.REACT_APP_AUTH_URL ?? "",
      API_URL: process.env.REACT_APP_API_URL ?? "",
      APP_VERSION: process.env.REACT_APP_VERSION ?? "locale",
      NOUBA_URL: process.env.REACT_APP_NOUBA_URL ?? "",
    }
  }
  
  // @ts-expect-error : Property __env does not exist on type Window & typeof globalThi
  const windowEnv = (typeof window !== 'undefined' && window.__env) ? window.__env : {}
  
  return {
    production: true,
    AUTH_URL: windowEnv.AUTH_URL ?? "",
    API_URL: windowEnv.BACK_URL ?? "",
    APP_VERSION: windowEnv.APP_VERSION ?? "",
    NOUBA_URL: windowEnv.NOUBA_URL ?? ""
  }
}

export default getEnv()
